import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '.././http-wrapper.service';
import {
  ICommunity,
  ICommunityDto,
  ICommunityPlaque,
} from '../../interfaces/community.interface';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { IContributor } from '../../interfaces/contributor.interface';
import { format, parseISO } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class CommunityService {
  constructor(private httpWrapperService: HttpWrapperService) {}

  CommunitySharable(id?: string | null, campaignId?: string | null): Observable<{ campaignId?: number, communityId?: number }> {
    const url = `CommunitySharable/?communityAirtableId=${id}&campaignAirtableId=${campaignId}`;
    const options: IHttpRequestOptions = { url: url };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: { campaignId?: number, communityId?: number }) => response));
  }
  
  getCommunityById(id: number): Observable<ICommunity> {
    const url = `community/${id}`;
    const options: IHttpRequestOptions = { url: url };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: ICommunity) => response));
  }

  
  convertDateString(dateString: string) {
    const date = parseISO(dateString); // Parses the ISO string correctly
    const startOfDay = new Date(date.setHours(0, 0, 0, 0)); // Ensure UTC start of day
    const formattedDate = format(startOfDay, "yyyy-MM-dd'T'HH:mm:ss"); // Format the date
    return formattedDate;
  }

  updateCommunity(id: number, community: ICommunity): Observable<ICommunity> {
    community.freeTrialStartDate= community.freeTrialStartDate ? this.convertDateString(community.freeTrialStartDate.toString()) : community.freeTrialStartDate;
    community.freeTrialEndDate= community.freeTrialEndDate ? this.convertDateString(community.freeTrialEndDate.toString()) : community.freeTrialEndDate;
    community.subscriptionStartDate= community.subscriptionStartDate ? this.convertDateString(community.subscriptionStartDate.toString()) : community.subscriptionStartDate;
    community.subscriptionEndDate= community.subscriptionEndDate ? this.convertDateString(community.subscriptionEndDate.toString()) : community.subscriptionEndDate;
    const url = `community/update/${id}`;
    const options: IHttpRequestOptions = { url: url };
    options.body = community;
    return this.httpWrapperService
      .putFromApiGateWay(options)
      .pipe(map((response: ICommunity) => response));
  }

  updateCommunityPhoto(
    id: number,
    type: 'cover' | 'profile',
    blobUrl: string,
  ): Observable<string> {
    const url = `${type}/${id}`;
    const options: IHttpRequestOptions = { url: url };
    options.body = {
      blobUrl: blobUrl,
    };
    return this.httpWrapperService
      .putFromApiGateWay(options)
      .pipe(map((response: string) => response));
  }

  createCommunity(community: ICommunityDto): Observable<ICommunity> {
    const url = `community`;
    const options: IHttpRequestOptions = {
      url: url,
      body: community,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: ICommunity) => response));
  }

  getCommunityPlaques(communityId: number): Observable<ICommunityPlaque> {
    const url = `CommunityPlaques/${communityId}`;
    const options: IHttpRequestOptions = { url: url };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: ICommunityPlaque) => response));
  }

  getCommunityUsers(communityId: number, campaignId: number): Observable<IContributor[]> {
    const url = `LinkedUserCommunity/${communityId}/${campaignId}`;
    const options: IHttpRequestOptions = { url: url };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IContributor[]) => response));
  }

  generateSampleData(communityId: number, email: string): Observable<string> {
    const url = `sampledata/community/${communityId}`;
    const options: IHttpRequestOptions = {
      url: url,
      body: {
        "IsOrganicSignUp": true,
        "Email": email,
      },
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: string) => response));
  }
}


